import React, { useState, useEffect, memo } from 'react';
import json from '../../../../Auditoria/index.json';
import { Objeto } from '../../../../../../Context/Models';
import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs } from '@syncfusion/ej2-react-grids'
import { Button, Card, FormGroup, Elevation, H2, InputGroup, Icon, MenuItem, ButtonGroup } from '@blueprintjs/core';
import { Select, MultiSelect } from "@blueprintjs/select";
import moment from 'moment';
import {
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  GridComponent,
  Page,
  Inject,
  Filter,
  Group,
  ExcelExport,
  PdfExport,
  Toolbar,
  ToolbarItems,
  Grid,
  FilterSettingsModel,
  Sort,
  Resize
} from '@syncfusion/ej2-react-grids';
import './style.css'
import { Identificador } from '../../../../../../Services/Controllers';

L10n.load(json)

function App({}: any) {
  const [getData, setData] = useState<Array<any>>([]);
  let preTotalValue: number = 0;
  let preData: Array<any> = [];
  const filterOptions: FilterSettingsModel = {
    ignoreAccent: true,
    immediateModeDelay: 200,
    mode: "Immediate",
    type: 'Excel'
  }
  let sum: number = 0;
  let grid: Grid | null;
  const toolbarOptions: ToolbarItems[] = [/*'PdfExport', 'CsvExport'*/]
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs | any) => {
    args.cell.cellHeight = 10;
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(2).textAlign = "Right";
  }
  const toolbarClick = (args: any) => {
    console.log('pre-grid')
    if (grid) {
      console.log(args.item.id)
      if (args.item.id === 'grid_pdfexport') {
        grid.pdfExport({
          fileName: `Vendas No Tempo ${moment(new Date(), true).format("YYYY-MM-DD")}.pdf`,
          pageOrientation: "Landscape",
          header: {
            fromTop: 0,
            height: 130,
            contents: [
              {
                type: 'Text',
                value: `${moment(new Date(), true).format("DD/MM/YYYY HH:mm:ss")}`,
                position: { x: 880, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 13 },
              },
            ]
          },
          footer: {
            contents: [
              {
                type: 'Text',
                value: `Powered by DigitalDEV`,
                position: { x: 0, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 10 },
              },
              {
                format: 'Página {$current} de {$total}',
                pageNumberType: "Numeric",
                position: { x: 910, y: 50 },
                style: {
                  fontSize: 13,
                  hAlign: "Right",
                  textBrushColor: '#000000',
                },
                type: 'PageNumber',
              }
            ],
            fromBottom: 0,
            height: 100,
          },
          theme: {
            header: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            },
            record: {
              bold: false,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7)
            },
            caption: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            }
          },
          allowHorizontalOverflow: false,

        });
      }
      if (args.item.id === 'grid_excelexport') {
        grid.excelExport({
          dataSource: getData
        })
      }
      if (args.item.id === 'grid_csvexport') {
        grid.getColumnByField('PRINCIPAL').format = "N2"
        grid.getColumnByField('CORRECAO').format = "N2"
        grid.getColumnByField('JUROS').format = "N2"
        grid.getColumnByField('Total').format = "N2"
        grid.csvExport({
          dataSource: getData
        })
      }
    }
  }

  useEffect(() => {
    async function componentDidMount() {
      for(let i = 0; i < 10; i++) {
        preData.push({
          titulo: 1212121,
          data_venc: "02/01/2022",
          conc: "Não"
        })
      }
      await setData(preData)
      console.log(preData)
    }

    componentDidMount();
  }, [])

  return (
    <>
      <div style={{ maxWidth: '100%', overflow:"auto" }}>
        <GridComponent
          dataSource={getData}
          id='grid'
          height = "265px"
          allowSorting={true}
          allowMultiSorting={true}
          ref={g => grid = g}
          allowPaging={true}
          allowFiltering={true}
          pageSettings={{ pageSizes: [10, 20, 30], pageSize: 15 }}
          filterSettings={filterOptions}
          toolbarClick={toolbarClick}
          toolbar={toolbarOptions}
          pdfQueryCellInfo={pdfQueryCellInfo}
          pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
          allowPdfExport={false}
          allowResizing={true}
          allowExcelExport={false}>
          <ColumnsDirective>
            <ColumnDirective field='valor' headerText='VALOR' />
            <ColumnDirective field='faturado' headerText='FATURADO' />
            <ColumnDirective field='receber' headerText='RECEBER' />
            <ColumnDirective field='recebido' headerText='RECEBIDO' />
          </ColumnsDirective>
          <AggregatesDirective>
            <AggregateDirective>
              <AggregateColumnsDirective>
                <AggregateColumnDirective field="valor_liq" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
              </AggregateColumnsDirective>
            </AggregateDirective>
          </AggregatesDirective>
          <Inject services={[Page, Filter, Group, ExcelExport, PdfExport, ExcelExport, Toolbar, Aggregate, Sort, Resize]} />
        </GridComponent>
      </div>
    </>
  );
}

export default memo(App);